module.exports = __webpack_public_path__ + "img/Power Apps.be0c1c94.svg";